'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  color: black;\n  background-color: #ccc;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 1rem auto;\n  padding: 0.5rem;\n  font-size: 2rem;\n  .fa {\n    margin-right: 0.5em;\n    color: green;\n  }\n  &:hover {\n    cursor: pointer;\n    color: white;\n    background-color: #777;\n  }\n'], ['\n  color: black;\n  background-color: #ccc;\n  border: 1px solid black;\n  border-radius: 5px;\n  margin: 1rem auto;\n  padding: 0.5rem;\n  font-size: 2rem;\n  .fa {\n    margin-right: 0.5em;\n    color: green;\n  }\n  &:hover {\n    cursor: pointer;\n    color: white;\n    background-color: #777;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CloseButton = _styledComponents2.default.div(_templateObject);

exports.default = CloseButton;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/helpers/ok-button.js
// module id = 252
// module chunks = 0